<template>
  <Widget
    v-if="loaded"
    ref="widget"
    :config="config"
    :height="height"
    @click="onClick($event)"
    :isLoading="!loaded"
    :chartOptions="chartOptions"
    :series="series"
    @loading="loading = $event"
    type="bar"
  >
    <template v-slot:title> Последние поступления финансов </template>
  </Widget>
</template>

<script>
import { popupMenu } from "@/components/mixings";
export default {
  mixins: [popupMenu],
  components: {
    Widget: () => import("./widgets/chart"),
  },
  props: {
    height: { type: Number, default: 0 },
    config: { type: Object, default: () => {} },
  },
  data() {
    return {
      loaded: false,
      details: [],
      series: [],
      chartOptions: {
        dataLabels: {
          formatter: num => {
            if (num >= 1000000) {
              return (num / 1000000).toFixed(1) + "M";
            }
            if (num >= 1000) {
              return (num / 1000).toFixed(1) + "K";
            }
            return num.toString();
          },
        },
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
          toolbar: {
            show: !true,
          },
          zoom: {
            enabled: !true,
          },
        },

        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 10,
            borderRadiusApplication: "end", // 'around', 'end'
            borderRadiusWhenStacked: "last", // 'all', 'last'
            dataLabels: {
              total: {
                enabled: true,
                style: {
                  fontSize: "13px",
                  fontWeight: 900,
                },
              },
            },
          },
        },
        xaxis: {},
        yaxis: {},
        tooltip: {
          enabled: true,
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            const detail = w.config.xaxis.details;
            const data = w.config.xaxis.categories[dataPointIndex];
            let res = `Дата: ${data}`;
            detail.forEach(d => {
              let name = d.name; // || "Другое";
              let p = Math.round(d.data[dataPointIndex]);
              if (name) {
                res += (res ? "<br>" : "") + `${name}: ${p}`;
              }
            });
            return `<div class="tooltip" style="margin:10px">${res}</div>`;
          },
        },
        legend: {
          position: "right",
          offsetY: 40,
        },
        fill: {
          opacity: 1,
        },
      },
    };
  },
  created() {
    this.fitchData();
  },
  computed: {
    loading: {
      get() {
        return this.isLoading;
      },
      set(v) {
        this.$emit("loading", v);
      },
    },
  },
  methods: {
    onClick(e) {},
    async fitchData() {
      const ds = new Date().addDays(-60);
      const de = new Date().addDays(1);
      let res = await this.$axios.get("/accounting/doc/order_receipt", {
        params: {
          filters: {
            date_doc: [
              { condition: ">=", value: ds.date + " 00:00:00" },
              { condition: "<", value: de.date + " 00:00:00" },
            ],
            status: 2,
          },
        },
      });
      let series = [
        { name: "", data: [] },
        { name: "Объекты (Клиент) ", data: [] },
        { name: "Объекты (Инвестор) ", data: [] },
        { name: "Аренда", data: [] },
        { name: "Прочее", data: [] },
      ];
      let dates = [];
      let data = res.data.data;

      let i = 0;
      let v_max = 0;
      for (let d = new Date(de); d > ds; d.setDate(d.getDate() - 1)) {
        if (i < 7) {
          let v = 0;
          let s = [0, 0, 0, 0, 0];
          data
            .filter(el => new Date(el.date_doc).date == d.date)
            .forEach(el => {
              v += el.value;
              if (el.object_id && el.client_id) s[1] += el.value;
              else if (el.object_id && el.investor_id) s[2] += el.value;
              else if (el.object_rent_id) s[3] += el.value;
              else s[4] += el.value;
              /*
              s[1] += el.object_id && el.client_id ? el.value : 0;
              s[2] += el.object_id && el.investor_id ? el.value : 0;
              s[3] += el.object_rent_id ? el.value : 0;
              s[4] += !el.object_rent_id && !el.object_id ? el.value : 0;
  */
            });
          if (v) {
            series[0].data.unshift(v);
            series[1].data.unshift(s[1] || 0);
            series[2].data.unshift(s[2] || 0);
            series[3].data.unshift(s[3] || 0);
            series[4].data.unshift(s[4] || 0);
            v_max = v > v_max ? v : v_max;
            i++;
            dates.unshift(d.date);
          }
        }
      }
      //    console.log({ dates, series });

      this.series = [series[0]];
      // this.series = series;
      this.details = series;
      this.chartOptions.xaxis = {
        details: series,
        labels: {
          show: true,
          rotate: -90,
          rotateAlways1: Boolean,
          formatter: function (value) {
            const date = new Date(value);
            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();
            //   return `${day}.${month}`;
            return date.date;
          },
        },
        type1: "datetime",
        categories: [...dates],
      };
      this.chartOptions.yaxis = {
        show: false,
        min: 10000,
        max: v_max,
        logarithmic: true,
        logBase: 10,
        labels: {
          formatter: num => {
            if (num >= 1000000) {
              return (num / 1000000).toFixed(1) + "M";
            }
            if (num >= 1000) {
              return (num / 1000).toFixed(1) + "K";
            }
            return num.toFixed(1).toString();
          },
        },
      };
      this.loaded = true;
    },
  },
};
</script>
